import { ArrowDownAZ, ArrowDownZA, List } from 'lucide-react';
import { Button } from './ui/button';
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { getLabelValue } from '@/utils/getLabelValue';
import { useState } from 'react';
import { Drawer, DrawerContent, DrawerHeader, DrawerTitle, DrawerTrigger } from './ui/drawer';

interface SortAttendeesProps {
  sortBy: 'firstName' | 'lastName' | 'companyName' | 'email';
  setSortBy: (value: 'firstName' | 'lastName' | 'companyName' | 'email') => void;
  sortDirection: 'asc' | 'desc';
  setSortDirection: (value: 'asc' | 'desc') => void;
  isMobile?: boolean;
}

export function SortAttendees({ sortBy, setSortBy, sortDirection, setSortDirection, isMobile = false }: SortAttendeesProps) {
  const [sheetOpen, setSheetOpen] = useState(false);

  const sortOptions = [
    { value: 'firstName', label: getLabelValue('FirstName') },
    { value: 'lastName', label: getLabelValue('LastName') },
    { value: 'companyName', label: getLabelValue('CompanyName') },
    { value: 'email', label: getLabelValue('Email') },
  ];
  if (isMobile) {
    return (
      <div className="flex items-center gap-2 py-2">
        <Drawer open={sheetOpen} onOpenChange={setSheetOpen}>
          <DrawerTrigger asChild>
            <Button variant="outline" className="flex gap-2 items-center">
              <List className="w-4 h-4" />
              {sortOptions.find(o => o.value === sortBy)?.label}
            </Button>
          </DrawerTrigger>
          <DrawerContent className="p-4">
            <DrawerHeader>
              <DrawerTitle>{getLabelValue('SortBy')}</DrawerTitle>
            </DrawerHeader>
            <div className="flex flex-col gap-2 mt-4">
              {sortOptions.map(option => (
                <Button
                  key={option.value}
                  variant={sortBy === option.value ? 'default' : 'outline'}
                  onClick={() => {
                    setSortBy(option.value as any);
                    setSheetOpen(false);
                  }}
                >
                  {option.label}
                </Button>
              ))}
            </div>
          </DrawerContent>
        </Drawer>

        <Button variant={'ghost'} className="p-2 rounded" onClick={() => setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc')}>
          {sortDirection === 'asc' ? <ArrowDownAZ className="w-4 h-4" /> : <ArrowDownZA className="w-4 h-4" />}
        </Button>
      </div>
    );
  }

  // Desktop version with Select
  return (
    <div className="flex items-center gap-2 py-2">
      <Select value={sortBy} onValueChange={value => setSortBy(value as any)}>
        <SelectTrigger className="w-40">
          <SelectValue placeholder="Select field" />
        </SelectTrigger>
        <SelectContent className="z-50">
          <SelectGroup>
            {sortOptions.map(option => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>

      <Button variant={'ghost'} className="p-2 rounded" onClick={() => setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc')}>
        {sortDirection === 'asc' ? <ArrowDownAZ className="w-4 h-4" /> : <ArrowDownZA className="w-4 h-4" />}
      </Button>
    </div>
  );
}
